export default __webpack_public_path__ + "static/media/17339.62412cb4.png";